export const enum ERowType {
  // Etapa
  STAGE = 0,
  // Composição
  TASK = 1,
  // Insumo
  RESOURCE = 2,
  // Branco
  BLANK = 3,
}

export const enum EContentType {
  LABOR = 1,
  MATERIAL = 2,
  EQUIPMENT = 3,
  TASK = 4,
  OTHER = 5,
}

export const enum EContentTypeText {
  LABOR = "labor",
  MATERIAL = "material",
  EQUIPMENT = "equipment",
  TASK = "task",
  OTHER = "other",
}



// WEBPACK FOOTER //
// ./src/common/enums/WBSRow.ts